import { BaseService } from "services/_baseService";

class CategoriesAdminService extends BaseService<any> {
  constructor() {
    super(`categories`);
  }
}

export default new CategoriesAdminService();
